/** Canonical site URL for SEO (robots, sitemap, metadata). Override with NEXT_PUBLIC_SITE_URL in production. */
export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL || "https://filizkozmetik.net";

/** Facebook App ID for `fb:app_id` (Open Graph / Sharing Debugger). Set FACEBOOK_APP_ID in env. */
export const FACEBOOK_APP_ID =
  process.env.FACEBOOK_APP_ID?.replace(/\s+/g, "") || undefined;
